/**
 * Helpers para determinar el tipo de nota (promo o noticia)
 */

export type NoteType = 'promo' | 'noticia' | 'otro';

export const getNoteType = (categoryName?: string | null, categoryId?: string | null): NoteType => {
  if (!categoryName) return 'otro';
  
  const category = categoryName.toLowerCase();
  if (category.includes('promo')) {
    return 'promo';
  }
  if (category.includes('noticia')) {
    return 'noticia';
  }
  return 'otro';
};

export const getContentTypeLabel = (noteType: NoteType, plural = false): string => {
  if (noteType === 'promo') {
    return plural ? 'promos' : 'promo';
  }
  if (noteType === 'noticia') {
    return plural ? 'noticias' : 'noticia';
  }
  return plural ? 'contenidos' : 'contenido';
};

export const getVotingContextText = (noteType: NoteType): string => {
  const label = getContentTypeLabel(noteType, true);
  return `Tu voto ayuda a la comunidad a descubrir las mejores ${label}`;
};

export const getVotingPromptText = (noteType: NoteType): string => {
  const singular = getContentTypeLabel(noteType, false);
  return `Para votar en ${singular}s, debes tener una sesión activa.`;
};
